import Icon from '../../../components/AppIcon';

const CommunityStats = () => {
  const stats = [
    {
      id: 1,
      icon: 'Users',
      value: '١٠٠٠+',
      label: 'كاتب نشط',
      labelEn: 'Active Writers',
      color: 'var(--color-primary)'
    },
    {
      id: 2,
      icon: 'BookOpen',
      value: '٢٠,٠٠٠+',
      label: 'مقال منشور',
      labelEn: 'Published Articles',
      color: 'var(--color-accent)'
    },
    {
      id: 3,
      icon: 'Heart',
      value: '٢ مليون',
      label: 'تفاعل شهري',
      labelEn: 'Monthly Engagements',
      color: 'var(--color-error)'
    },
    {
      id: 4,
      icon: 'Globe',
      value: '٢٢',
      label: 'دولة عربية',
      labelEn: 'Arab Countries',
      color: 'var(--color-success)'
    }
  ];

  return (
    <section className="w-full bg-gradient-to-br from-[var(--color-card)] to-[var(--color-muted)] py-8 md:py-12 lg:py-16" style={{ fontFamily: "'Amiri', serif" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-4 md:mb-6">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[var(--color-foreground)] mb-3 md:mb-4">
            مجتمع ثقافي متنامٍ
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto" style={{ fontFamily: "'Amiri', serif", fontWeight: 400 }}>
            انضمّ إلى مجموعة موهوبة من الكُتَّاب والمبدعين الذين يهدفون إلى توثيق التراث وإحياء الوسط الثقافي العربي.
          </p>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[var(--color-foreground)] mt-12 md:mt-16 lg:mt-20" style={{ fontFamily: 'Aref Ruqaa, serif' }}>
            طموحنا
          </h1>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
          {stats?.map((stat) => (
            <div
              key={stat?.id}
              className="flex flex-col items-center justify-center group"
            >
              <div
                className="w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 rounded-full flex flex-col items-center justify-center shadow-warm hover:shadow-warm-lg transition-all duration-300 group-hover:scale-105"
                style={{ backgroundColor: `${stat?.color}15` }}
              >
                <div
                  className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full flex items-center justify-center mb-2 md:mb-3 group-hover:scale-110 transition-transform"
                  style={{ backgroundColor: `${stat?.color}30` }}
                >
                  <Icon name={stat?.icon} size={24} color={stat?.color} />
                </div>
                <div className="text-xl md:text-2xl lg:text-3xl font-bold mb-1" style={{ color: stat?.color }}>
                  {stat?.value}
                </div>
                <div className="text-xs md:text-sm text-[var(--color-muted-foreground)] font-medium px-2 text-center">
                  {stat?.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommunityStats;